import React, { useContext } from "react";

import { SessionStatus } from "@/autoGeneratedGlobalTypes";
import { InfoStatusEnum } from "@/components/constants";
import GlobalContext from "@/contexts/Global/GlobalContext";

import CancelledAlert from "../../alerts/cancelledAlert";
import ConnectionTroublesAlert from "../../alerts/connectionTroublesAlert";
import InProgressAlert from "../../alerts/inProgressAlert";
import ReviewEndedAlert from "../../alerts/reviewEndedAlert";
import UnavailableAlert from "../../alerts/unavailableAlert";
import WaitingAlert from "../../alerts/waitingAlert";
import ModalWrapper from "../../modalWrapper";

import type { SessionAlertRendererProps } from "./types";

/**
 * Компонент для рендеринга алертов в зависимости от статуса сессии
 *
 * Отображает различные модальные окна в зависимости от состояния сессии:
 * - Ожидание подключения
 * - Сессия в процессе
 * - Сессия отменена
 * - Проблемы с соединением
 * - И другие состояния
 */
const SessionAlertRenderer: React.FC<SessionAlertRendererProps> = ({
  alertStatus,
  client,
  expert,
  sessionId,
  sessionType,
}) => {
  const { isExpert } = useContext(GlobalContext);
  const receiver = isExpert ? client : expert;

  switch (alertStatus) {
    case SessionStatus.waiting:
      return (
        <ModalWrapper>
          <WaitingAlert
            client={client ?? undefined}
            expert={expert ?? undefined}
            isExpert={isExpert}
            sessionId={sessionId}
            sessionType={sessionType ?? undefined}
          />
        </ModalWrapper>
      );

    case InfoStatusEnum.ReviewEnded:
      return (
        <ModalWrapper>
          <ReviewEndedAlert receiver={receiver ?? undefined} />
        </ModalWrapper>
      );

    case InfoStatusEnum.Unavailable:
      return (
        <ModalWrapper>
          <UnavailableAlert receiver={receiver ?? undefined} />
        </ModalWrapper>
      );

    case InfoStatusEnum.Cancelled:
      return (
        <ModalWrapper>
          <CancelledAlert receiver={receiver ?? undefined} />
        </ModalWrapper>
      );

    case InfoStatusEnum.ConnectionTroubles:
      return (
        <ModalWrapper>
          <ConnectionTroublesAlert receiver={receiver ?? undefined} />
        </ModalWrapper>
      );

    case SessionStatus.in_progress:
      return (
        <ModalWrapper>
          <InProgressAlert receiver={receiver ?? undefined} />
        </ModalWrapper>
      );

    default:
      return null;
  }
};

export default SessionAlertRenderer;
